// extracted by mini-css-extract-plugin
export default {"productA":"product_productA__c8W7i"};